import { FAMILIES } from "./data";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {FAMILIES.map((f, i) => (
      <span key={f} className="flex items-center">
        <span className={`font-display text-5xl sm:text-7xl font-extrabold tracking-tight px-6 ${i % 3 === 1 ? "text-outline" : i % 7 === 0 ? "text-[var(--teal)]" : "text-[var(--text)]"}`}>{f}</span>
        <span className={`h-2.5 w-2.5 rounded-sm ${i % 5 === 2 ? "bg-[var(--amber)]" : "bg-[var(--teal)]"}`} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="families-marquee" aria-label="Supported gene families" className="marquee-wrap relative border-y border-[var(--line)] bg-[var(--surface)] py-10 overflow-hidden">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-6 flex justify-between font-mono text-xs uppercase tracking-[0.2em] text-[var(--muted)]">
      <span>60 oncology gene families</span>
      <span className="hidden sm:inline">RAS · PI3K · RTK · cell cycle · tumor suppressors</span>
    </div>
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
